import { connect } from "react-redux";

import { Actions as COMPANY_ACTIONS } from "../../store/actions/companyActions";

import { ArchiveBoxIcon, ClipboardIcon, ShareIcon } from "@/icons/outline";
import LayoutRoutes from "buddy/layout/LayoutRoutes";
import LayoutSidebar from "buddy/layout/LayoutSidebar";
import SectionedLayout from "buddy/layout/SectionedLayout";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Actions as PAYMENT_ACTIONS } from "../../store/actions/paymentActions";
import InvalidPermissions from "../company-pages/InvalidPermissions";
import ImportBambooDepartmentsModal from "../integrations/bamboo-hr/ImportDepartmentsModal";
import { getSettingsRoutes, getSettingsTabs } from "./companySettingsTabs";
import { copyToClipboard } from "@/helpers/ClipboardHelpers";

const Settings = ({
	isAdmin,
	isAdvisor,
	org,
	userPermissions,
	adminMigrateCompany,
	setArchiveModal,
	archivedStatus,
	showPricingModal,
	isDemo,
	jurisdiction,
}) => {
	const location = useLocation();
	const defaultPath = `/organisation/settings`;
	const tabPaths = location.pathname.replace(defaultPath, "").split("/");

	const [sections, routes] = useMemo(() => {
		const tabs = getSettingsTabs({ jurisdiction });
		const routes = getSettingsRoutes(tabs);

		return [tabs, routes];
	}, []);

	if (userPermissions === "None") return <InvalidPermissions />;

	return (
		<div className="overflow-hidden h-[calc(100vh-60px)]">
			<ImportBambooDepartmentsModal />
			<div className="content bg-gray-50">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading pb-10">Company Settings</h1>
						</div>
						<div className="pull-right">
							{!isDemo && archivedStatus != "Archived" ? (
								<div
									className="btn btn-default pull-right"
									onClick={() => setArchiveModal()}
								>
									<ArchiveBoxIcon style={{ height: "1.5em", float: "left" }} />
									<div style={{ float: "left" }}>Archive Account</div>
								</div>
							) : null}
							{archivedStatus == "Archived" && (
								<div
									className="btn btn-default pull-right"
									onClick={() => showPricingModal()}
								>
									<ArchiveBoxIcon style={{ height: "1.5em", float: "left" }} />
									<div style={{ float: "left" }}>Unarchive Account</div>
								</div>
							)}
							{isAdmin && (
								<>
									<div
										className="btn btn-default pull-right"
										onClick={() => copyToClipboard(org)}
										style={{ marginRight: 10 }}
									>
										<ClipboardIcon style={{ height: "1.5em", float: "left" }} />
										<div style={{ float: "left" }}>Copy ID</div>
									</div>

									<div
										className="btn btn-default pull-right"
										onClick={() => adminMigrateCompany()}
										style={{ marginRight: 10 }}
									>
										<ShareIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
										<div style={{ float: "left" }}>Migrate to Staging</div>
									</div>
								</>
							)}
						</div>
					</div>
				</div>
			</div>
			<SectionedLayout>
				<LayoutSidebar
					{...{
						sections,
						defaultPath,
						conditions: {
							jurisdiction,
							isAdmin,
							isAdvisor,
							tabPaths,
						},
					}}
				/>
				<LayoutRoutes
					{...{
						routes,
						defaultPath,
						conditions: {
							jurisdiction,
							isAdmin,
							isAdvisor,
							tabPaths,
						},
					}}
				/>
			</SectionedLayout>
		</div>
	);
};

const mapStateToProps = (state) => {
	const userPermissions = state?.permissions?.my?.permissions?.settings;
	const isDemo = state?.company?.settings?.isDemo;

	return {
		isAdvisor: state.my?.profile?.isAdvisor,
		isAdmin: state?.my?.profile?.isAdmin,
		org: state?.company?.settings?.org,
		jurisdiction: state?.company?.settings?.jurisdiction,
		userPermissions,
		archivedStatus: state?.company?.settings?.status,
		isDemo,
	};
};

const mapDispatchToProps = (dispatch) => ({
	companyTab: (tab) => dispatch(COMPANY_ACTIONS.companyTab(tab)),
	adminMigrateCompany: () => dispatch(COMPANY_ACTIONS.adminMigrateCompany()),
	setArchiveModal: () => dispatch(COMPANY_ACTIONS.setArchiveModal(true)),
	showPricingModal: (isNew) => dispatch(PAYMENT_ACTIONS.showPricingModal(true, isNew ?? false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
